(() => {
  if (window.__RavinEditorialReel26) return;
  window.__RavinEditorialReel26 = true;
  const roots = new WeakSet();
  const states = new WeakMap();
  const moving = new Set();
  const ar = () => (document.documentElement.lang || '').toLowerCase().startsWith('ar');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const asNode = (tag, className, text) => {
    const n = document.createElement(tag);
    if (className) n.className = className;
    if (text !== undefined) n.textContent = text;
    return n;
  };
  const number = value => String(value).padStart(2, '0');
  const watch = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { const state = [...moving].find(item => item.node === entry.target); if (state) state.visible = entry.isIntersecting; });
    wake();
  }, {threshold:.05}) : null;
  let raf = 0;
  function wake() {
    if (!raf && !reduced.matches && [...moving].some(item => item.visible && item.node.isConnected)) raf = requestAnimationFrame(tick);
  }
  function tick(time) {
    raf = 0;
    if (reduced.matches || document.hidden) return;
    for (const item of Array.from(moving)) {
      if (!item.node.isConnected) { moving.delete(item); watch?.unobserve(item.node); continue; }
      if (!item.visible || time < item.pauseUntil) { item.last = time; continue; }
      const rail = item.rail;
      const half = rail.scrollWidth / 2;
      if (half < rail.clientWidth + 8) continue;
      const dt = Math.min(80, Math.max(0, time - (item.last || time)));
      item.last = time;
      if (item.mode === 'marquee') {
        rail.scrollLeft += dt * .023;
        if (rail.scrollLeft >= half) rail.scrollLeft -= half;
      } else if (time - item.lastStep >= 2550) {
        const frame = rail.querySelector('.rve-frame');
        const step = (frame?.getBoundingClientRect().width || 144) + 5;
        const next = rail.scrollLeft + step;
        if (next >= half) rail.scrollLeft = next - half;
        else rail.scrollTo({left:next,behavior:'smooth'});
        item.lastStep = time;
      }
    }
    if ([...moving].some(item => item.visible && item.node.isConnected)) raf = requestAnimationFrame(tick);
  }
  function moduleFor(card, numberOfModule, animated) {
    const source = card.querySelector('template[data-rve-source]');
    const photos = Array.from(source?.content.querySelectorAll('[data-rve-image]') || []).map((n, i) => ({
      thumb:n.dataset.rveThumb, full:n.dataset.rveFull, alt:n.dataset.rveAlt || '', editorial:n.dataset.rveEditorial === '1', index:i + 1
    })).filter(photo => photo.full && photo.thumb);
    if (photos.length === 0) return null;
    const editorial = photos.findIndex(photo => photo.editorial);
    const selected = editorial >= 0 ? editorial : Math.min(3, photos.length - 1);
    const chosen = photos[selected];
    const href = card.getAttribute('href') || '#';
    const title = card.querySelector('h3')?.textContent?.trim() || '';
    const prices = card.querySelector('[class*="ai-product-price-"]');
    const old = prices?.querySelector('[class*="ai-price-original-"]')?.textContent?.trim() || '';
    const now = prices?.querySelector('[class*="ai-price-final-"]')?.textContent?.trim() || '';
    const saved = prices?.querySelector('[class*="ai-price-savings-"]')?.textContent?.trim() || '';
    const regular = !now ? prices?.textContent?.trim() || '' : '';
    const container = asNode('section','rve-showcase rve-showcase--' + (numberOfModule % 2 ? 'contact' : 'offset'));
    container.setAttribute('aria-label', ar() ? 'ريفين: عرض خاص للقطعة القادمة' : 'RAVIN: next look feature');
    container.dataset.rveShowcase = '';
    const strip = asNode('div','rve-strip');
    const head = asNode('div','rve-strip__head');
    head.append(asNode('strong','', 'RAVIN / ' + (ar() ? 'اللوك الجاي' : 'NEXT LOOK') + ' ' + number(numberOfModule)),asNode('span','rve-strip__stamp',(ar() ? 'لقطات' : 'FRAME SERIES') + ' / ' + number(photos.length)));
    const rail=asNode('div','rve-strip__rail');
    rail.setAttribute('dir','ltr');
    rail.setAttribute('aria-label',ar()?'صور المنتج بالأبيض والأسود':'Product photos in black and white');
    const track=asNode('div','rve-strip__track');
    for (let copy = 0; copy < 2; copy++) {
      photos.forEach((photo,index)=>{
        const link=asNode('a','rve-frame'+(index===selected?' is-featured':''));
        link.href=href;
        link.setAttribute('aria-label',(ar()?'عرض المنتج، صورة ':'View product, image ')+number(index+1));
        if (copy) {link.setAttribute('aria-hidden','true');link.tabIndex=-1;}
        const image=asNode('img','');
        image.src=photo.thumb;
        image.alt=copy?'':photo.alt;
        image.loading='lazy';
        image.decoding='async';
        image.width=460;image.height=610;
        link.append(image,asNode('span','rve-frame__number',number(index+1)));
        track.append(link);
      });
    }
    rail.append(track);
    strip.append(head,rail,asNode('div','rve-strip__tick'));
    const hero=asNode('div','rve-hero');
    const imageLink=asNode('a','rve-hero__picture');
    imageLink.href=href;
    const big=asNode('img','');
    big.src=chosen.full;big.alt=chosen.alt || title;big.loading='lazy';big.decoding='async';
    big.width=1440;big.height=1680;
    imageLink.append(big,asNode('span','rve-hero__picture-note',(ar()?'لقطة ':'FRAME ')+number(chosen.index)));
    const copy=asNode('div','rve-hero__copy');
    const eyebrow=asNode('div','rve-hero__eyebrow');
    eyebrow.append(asNode('span','',ar()?'ريفين / اللوك الجاي':'RAVIN / NEXT LOOK'),asNode('span','',number(chosen.index)+' / '+number(photos.length)));
    const h=asNode('h2','rve-hero__name',title);
    const price=asNode('div','rve-hero__prices');
    if (old) price.append(asNode('span','rve-hero__was',old));
    if (now) price.append(asNode('span','rve-hero__now',now));
    else if (regular) price.append(asNode('span','rve-hero__regular',regular));
    if(saved) price.append(asNode('span','rve-hero__save',saved));
    const cta=asNode('a','rve-hero__cta');
    cta.href=href;
    cta.append(asNode('span','',ar()?'شوف القطعة':'VIEW PRODUCT'),asNode('span','','↗'));
    const note=asNode('div','rve-hero__fineprint',ar()?'قطعة واحدة، لقطات مختلفة.':'ONE PRODUCT / EVERY ANGLE.');
    copy.append(eyebrow,h,price,cta,note);
    hero.append(imageLink,copy);
    container.append(strip,hero);
    if (animated && !reduced.matches) {
      const item={node:container,rail,mode:numberOfModule%2?'marquee':'step',pauseUntil:0,last:0,lastStep:0,visible:!watch};
      const pause=()=>{item.pauseUntil=performance.now()+7000;item.lastStep=performance.now();};
      rail.addEventListener('pointerdown',pause,{passive:true});
      rail.addEventListener('wheel',pause,{passive:true});
      rail.addEventListener('focusin',pause);
      moving.add(item);
      watch?.observe(container);
      wake();
    }
    return container;
  }
  function hasNamedEditorialImage(card) {
    const template = card.querySelector('template[data-rve-source]');
    return Boolean(template?.content.querySelector('[data-rve-image][data-rve-editorial="1"]'));
  }
  // One exclusive editorial placement per featured product; source cards remain
  // hidden in the DOM so filtering, sorting and re-rendering can restore them.
  function render(root) {
    const grid=root.querySelector('[data-rve-grid]');
    if (!grid) return;
    const cards=Array.from(grid.children).filter(el =>
      el.matches('a[data-ravin-price-card]') && (!el.hidden || el.dataset.rveFeatured==='1')
    );
    const every=Math.max(4,Number(grid.dataset.rveEvery)||8);
    const maximum=Math.max(1,Math.min(2,Number(grid.dataset.rveMax)||2));
    const enabled=grid.dataset.rveEnabled!=='false';
    const autoEditorial=grid.dataset.rveAutoEditorial!=='false';
    const existingModules=grid.querySelectorAll(':scope > .rve-showcase');
    const existingFeatured=cards.filter(card=>card.dataset.rveFeatured==='1');
    const token=(enabled?'on':'off')+'|'+(autoEditorial?'auto':'manual')+'|'+every+'|'+maximum+'|'
      +cards.map(card=>(card.dataset.ravinProductId||card.href)+':'+(hasNamedEditorialImage(card)?'e':'n')).join('|');
    const prev=states.get(grid);
    if(prev?.token===token && existingModules.length===prev.count && existingFeatured.length===prev.count)return;

    existingFeatured.forEach(card=>{delete card.dataset.rveFeatured;card.hidden=false;});
    existingModules.forEach(node=>node.remove());
    for(const item of Array.from(moving)){
      if(!item.node.isConnected){moving.delete(item);watch?.unobserve(item.node);}
    }
    if(!enabled || !cards.length){states.set(grid,{token,count:0});return;}

    const eligible=cards.filter(card=>
      Boolean(card.querySelector('template[data-rve-source]')?.content.querySelector('[data-rve-image]'))
    );
    if(!eligible.length){states.set(grid,{token,count:0});return;}

    // 26 unique products = 24 regular cards + 2 showcases, never duplicated.
    // Partial/filtered pages always have one showcase where an image is available;
    // a second is chosen only if it makes the remaining four-column rows complete.
    const useTwo=cards.length>=17 && cards.length%4===2 && maximum>=2 && eligible.length>=2;
    const desired=useTwo?2:1;
    const selected=[];
    for(let slot=0;slot<desired;slot++){
      const target=slot===0?8:17;
      const remaining=eligible.filter(card=>!selected.includes(card));
      if(!remaining.length)break;
      const named=autoEditorial?remaining.filter(hasNamedEditorialImage):[];
      const candidates=named.length?named:remaining;
      const chosen=candidates.slice().sort((a,b)=>
        Math.abs(cards.indexOf(a)-target)-Math.abs(cards.indexOf(b)-target)
      )[0];
      selected.push(chosen);
    }
    const regular=cards.filter(card=>!selected.includes(card));
    let shown=0;
    selected.forEach((card,index)=>{
      const module=moduleFor(card,index+1,grid.dataset.rveMotion!=='false');
      if(!module)return;
      card.dataset.rveFeatured='1';
      card.hidden=true;
      // Insert only after complete four-column rows (8 or 16 cards).
      const anchor=regular[Math.min((index+1)*every,regular.length)-1];
      if(anchor)anchor.insertAdjacentElement('afterend',module);
      else card.insertAdjacentElement('beforebegin',module);
      shown++;
    });
    states.set(grid,{token,count:shown});
  }
  function init(scope) {
    scope.querySelectorAll?.('[data-ravin-results-root]').forEach(root=>{
      if(roots.has(root)||!root.querySelector('[data-rve-grid]'))return;
      roots.add(root);
      let scheduled=false;
      const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;render(root);});};
      root.addEventListener('ravin:results-replaced',schedule);
      const grid=root.querySelector('[data-rve-grid]');
      new MutationObserver(records=>{
        if(records.some(rec=>Array.from(rec.addedNodes).concat(Array.from(rec.removedNodes)).some(node=>node.nodeType===1 && (node.matches?.('[data-ravin-price-card],.rve-showcase')||node.querySelector?.('[data-ravin-price-card]')))))schedule();
      }).observe(grid,{childList:true});
      schedule();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('visibilitychange',wake);
  reduced.addEventListener?.('change',wake);
})();
